import { Authenticated, Refine } from '@refinedev/core';
import routerProvider from '@refinedev/react-router-v6';
import { Route, Routes } from 'react-router-dom';
import { authProvider } from '../authProvider';
import { ToastProvider } from '../contexts/ToastContext';
import { dataProvider } from '../dataProvider';
import { AdminLayout } from './layout';
import { LoginPage } from './login';

// Use standard router provider for now
// const customRouterProvider = routerProvider;

function Admin() {
	return (
		<ToastProvider>
			<Refine
				dataProvider={dataProvider}
				authProvider={authProvider}
				routerProvider={routerProvider}
				resources={[
					// Removed projects resource to prevent routing conflicts
					// All project routes handled by PageTransition
					{
						name: 'content_sections',
						list: '/admin/content',
					},
					{
						name: 'field_definitions',
						list: '/admin/fields',
					},
					{
						name: 'categories',
						// No routes defined - managed within projects interface
					},
					{
						name: 'project_categories',
						// Junction table - no routes needed
					},
					{
						name: 'media',
						list: '/admin/media',
					},
				]}>
				<Routes>
					<Route path='login' element={<LoginPage />} />
					<Route
						path='*'
						element={
							<Authenticated key='admin' fallback={<LoginPage />}>
								<AdminLayout />
							</Authenticated>
						}
					/>
				</Routes>
			</Refine>
		</ToastProvider>
	);
}

export default Admin;
